import { render, staticRenderFns } from "./StockTakings.vue?vue&type=template&id=281b3c64&"
import script from "./StockTakings.vue?vue&type=script&lang=js&"
export * from "./StockTakings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports